export default function Spade({ className = "", size = 64, glow = false }) {
    return (
        <svg
            viewBox="0 0 64 80"
            width={size}
            height={(size * 80) / 64}
            className={className}
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="sp-body" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#fdfbf7" />
                    <stop offset="55%" stopColor="#e8dccb" />
                    <stop offset="100%" stopColor="#a58e6a" />
                </linearGradient>
                <linearGradient id="sp-shine" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="rgba(255,255,255,0.75)" />
                    <stop offset="100%" stopColor="rgba(255,255,255,0)" />
                </linearGradient>
                <filter id="sp-glow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="2.4" result="b" />
                    <feMerge>
                        <feMergeNode in="b" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
            <g filter={glow ? "url(#sp-glow)" : undefined}>
                {/* Body */}
                <path
                    d="M32 3 C32 3 8 26 8 42 C8 52 16 60 24 60 C28 60 30 58 32 55 C34 58 36 60 40 60 C48 60 56 52 56 42 C56 26 32 3 32 3 Z"
                    fill="url(#sp-body)"
                    stroke="rgba(0,0,0,0.35)"
                    strokeWidth="0.8"
                />
                {/* Highlight */}
                <path
                    d="M32 8 C32 8 14 27 14 40 C14 44 17 47 20 47 C22 47 24 44 27 40 C29 37 32 30 32 8 Z"
                    fill="url(#sp-shine)"
                    opacity="0.55"
                />
                {/* Stem */}
                <path
                    d="M24 76 C28 68 30 62 32 55 C34 62 36 68 40 76 Z"
                    fill="url(#sp-body)"
                    stroke="rgba(0,0,0,0.35)"
                    strokeWidth="0.8"
                />
            </g>
        </svg>
    );
}
